import React from "react";
import styles from "./styles.module.css";

function EMandateSuccess() {
  return (
    <div className={styles.main}>
      <div className={styles.container}>
        <img src="/feemonklogo.png" alt="" className={styles.logo} />
        <div className={styles.iconWrapper}>
          <svg
            viewBox="0 0 64 64"
            className={styles.icon}
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="32" cy="32" r="32" fill="#e6f7ee" />
            <path
              d="M18 33l10 10 18-20"
              stroke="#27ae60"
              strokeWidth="4"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="none"
            />
          </svg>
        </div>
        <div className={styles.textContainer}>
          <p className={styles.heading}>Thank You!</p>
          <p className={styles.subText}>
            Your eMandate Process has been successfully completed.
          </p>
          <p className={styles.closeText}>You can close this page.</p>
        </div>
      </div>
    </div>
  );
}

export default EMandateSuccess;
